import React from 'react';
import { Box, Heading, BoxProps } from '@hover/blueprint';

interface Props extends BoxProps {
  id: string;
  heading: string;
}

const SectionContainer: React.FC<Props> = ({
  id,
  heading,
  children,
  ...restProps
}) => (
  <Box flexDir="column" mb={800} key={id} position="relative" {...restProps}>
    <Box
      w="100%"
      h="1px"
      position="absolute"
      top={{ base: '120px', tablet: '90px' }}
      left={0}
      id={id}
    />
    <Heading as="h2" size={500} fontWeight={700} marginBottom={500}>
      {heading}
    </Heading>
    {children}
  </Box>
);

export default SectionContainer;
